import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBed } from "@fortawesome/free-solid-svg-icons";
import PlanItemBase from "./PlanItemBase";
import ItemDescription from "./ItemDescription";

const AccommodationItem = ({ item }) => {
  const time = new Date(item.startDate).toLocaleTimeString("pl-PL", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <PlanItemBase
      icon={<FontAwesomeIcon icon={faBed} className="plan-icon" />}
      time={time}
      name={item.name}
    >
      <div className="item-details">
        {item.accommodationBoard && (
          <p>
            <strong>Wyżywienie:</strong> {item.accommodationBoard}
          </p>
        )}
        {item.accommodationType && (
          <p>
            <strong>Kategoria obiektu noclegowego:</strong> {item.accommodationType}
          </p>
        )}
        {item.link && (
          <p>
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              Link
            </a>
          </p>
        )}
        {item.description && (
          <ItemDescription description={item.description} />
        )}
      </div>
    </PlanItemBase>
  );
};

export default AccommodationItem;
